import React, { useContext, useState, useEffect,useRef } from 'react'
import {dataContext,isNumeric} from '../utils.js'
import icon from '../icons.svg' 


function EditIrg({Capt,title,Value,ValueHistory,typeVal,pid,setVal,width1,width2,disabled=false,minus=false}){
    let data=[]
    const context=useContext(dataContext)
    data=context.data[typeVal]
    if (typeof data === 'undefined') data=[]
    data=data.filter(el=>el.id===pid)
    if (ValueHistory&&data.length === 0) data=ValueHistory

    const now=new Date()
    now.setUTCHours(0,0,0,0)
    const currDate=now.toISOString().split('.')[0]+'Z'
    let modDate=undefined

    const node = useRef(null);

    const [showHistory, setShow] = useState(false);


    const changeHandler=(e)=>{
        setShow(false)
        if(!e){setVal('set',currDate,'0',modDate);return}
        if(e&&!isNumeric(e)) e=e.replace(',', '.')
        if(e&&isNumeric(e)) if (parseFloat(e)>=0||minus) setVal('set',currDate,e,modDate)
    }

    useEffect(() => {
        if (pid&&data.length === 0) {
            setTimeout(()=>{context.getData(typeVal,true,pid)},Math.floor(Math.random() * 200)) 
        } 
    },)

    useEffect(()=>{
        const listener = (event) =>{
            if(event.target.id==='irg_div') setShow(false)
            if (node.current && event.target && node.current.contains(event.target)) return
            setShow(false)
            } 
        if (showHistory) document.addEventListener("mousedown", listener)
        return () => {document.removeEventListener("mousedown", listener)}
    })
    
    let currVal=''
    data=data.map(el=>{return({...el,olddate:el.date,show:true})})
    if(Value){
        //data.forEach(el=>{const newel=Value.find(e=>e.date===el.date); if(newel){if(newel.act==='del') el.show=false;el.newdate=newel.newdate;el.value=newel.value} if(!currVal&&el.newdate<=currDate) currVal=el.value;})
        Value.forEach(el=>{
            const felold=data.find(e=>e.olddate===el.olddate&&el.olddate!==undefined)
            const fel=data.find(e=>e.date===el.date)
            //console.log(fel)
            if(felold) {
                if(el.act==='del') felold.show=false
                else if(el.act==='mod') felold.date=el.date
                else {felold.date=el.date;felold.value=el.value}
            }else if(fel){
                if(el.act==='del') fel.show=false
                else if(el.act==='set') fel.value=el.value
                //else fel.date=el.date
            }else{
                data.push({id:pid,date:el.date,value:el.value,show:true})
            }
        })
    }
    data=data.filter(el=>el.show&&el.date)
    data.sort((a,b)=>{if(a.date<b.date) return 1; if(a.date>b.date) return -1;return 0})
    data.forEach(el=>{
        if(!currVal&&el.date<currDate) currVal=el.value; else if(!currVal&&el.date===currDate) {currVal=el.value;modDate=el.olddate;}})
    if(currVal===null) currVal=''

    //console.log(data)
    //console.log(Value)
    //по F4 має відкритися

    const elId='id'+Math.random()

    if (showHistory) {
        const items=data.map((el,idx)=>{
            const stl=idx===0?{display:'flex',border:'1px solid'}:{display:'flex',border:'1px solid',borderTop:'none'}
            return(
            <div key={idx} style={stl}>
                <input style={{minWidth:'110px',width:'110px',border:'none',padding:'0 1px 0 0',boxSizing:'border-box',whiteSpace:'nowrap'}} type='date' value={el.date.substring(0,10)} onChange={(e)=>{setVal('mod',el.date,e.target.value+'T00:00:00Z',el.olddate)}} />
                <input style={{minWidth:'42px',width:Math.max(parseInt(width2)-127,42)+'px',textAlign:'right',border:'none',boxSizing:'border-box'}} type='text' value={el.value} 
                onChange={(e)=>{setVal('set',el.date,e.target.value,el.olddate)}} 
                onBlur={()=>{const newVal=parseFloat(el.value).toFixed(2); if(newVal!==el.value) setVal('set',el.date,newVal,el.olddate)}} />
                <img className='no-print' style={{width:'16px',height:'16px',position:'relative',cursor:'pointer',padding:'4px 0px'}} src={icon+'#dlt'} alt='' onClick={()=>{setVal('del',el.date,el.value,el.olddate)}}/>
            </div>

        )})
        /*items.push(
            <div key={-1} style={{display:'flex'}}>
                <input style={{minWidth:'110px',width:'110px',border:'none'}} type='date' value={null} onChange={(e)=>{console.log(e.target.value+'T00:00:00Z')}} />
                <div style={{minWidth:'38px',width:width2-127+'px',textAlign:'right',border:'none'}}>{'+'}</div>
            </div>
        )*/
        return(
        <label style={{display:'inline-flex', margin:'inherit',flexGrow:parseInt(width1)+parseInt(width2),maxWidth:parseInt(width1)*2+parseInt(width2)*2+'px'}} htmlFor={elId}><div style={{display:'inline-flex',minWidth:width1+'px',lineHeight:'24px',flexBasis:width1+'px',flexGrow:parseInt(width1)/10}}>{Capt+' '}</div>
        <div id='irg_div' ref={node} style={{display:'inline-flex',width:width2+'px',position:'relative',flexBasis:width2+'px',flexGrow:parseInt(width2),height:'24px'}} onKeyUp={e=>{if(e.key==='F4') setShow(false)}}>
            <input title={title} style={{width:'calc(100% - 26px)',textAlign:'right',padding:'0 22px 0 2px',flexShrink:'0',fontSize:'inherit',fontFamily:'inherit'}} type='text' value={currVal} id={elId} disabled={disabled}
            onChange={(e)=>{changeHandler(e.target.value)}} 
            onBlur={()=>{const newVal=parseFloat(currVal).toFixed(2); if(currVal&&newVal!==currVal) setVal('set',currDate,newVal,modDate)}} />
            <img className='no-print' style={{marginLeft:'-26px',width:'24px',height:'24px',cursor:'pointer'}} src={icon+'#cal'} alt='' onClick={()=>{setShow(false)}}/>
            <div style={{minWidth:'170px',right:'0px',top:'24px',width:width2-1+'px',position:'absolute',background:'#FFFFFF'}}>
                {items}
            </div>
        </div></label>
        )
    }
    else return(
        <label style={{display:'inline-flex', margin:'inherit',flexGrow:parseInt(width1)+parseInt(width2),maxWidth:parseInt(width1)*2+parseInt(width2)*2+'px'}} htmlFor={elId}><div style={{display:'inline-flex',minWidth:width1+'px',lineHeight:'24px',flexBasis:width1+'px',flexGrow:parseInt(width1)/10}}>{Capt+' '}</div>
        <div id='irg_div' ref={node} style={{display:'inline-flex',width:width2+'px',flexBasis:width2+'px',flexGrow:parseInt(width2),height:'24px'}} onKeyUp={e=>{if(e.key==='F4') setShow(disabled?false:true)}}>
            <input title={title} style={{width:'calc(100% - 26px)',textAlign:'right',padding:'0 22px 0 2px',flexShrink:'0',fontSize:'inherit',fontFamily:'inherit'}} type='text' value={currVal} id={elId} disabled={disabled}
            onChange={(e)=>{changeHandler(e.target.value)}} 
            onBlur={()=>{const newVal=parseFloat(currVal).toFixed(2); if(currVal&&newVal!==currVal) setVal('set',currDate,newVal,modDate)}} 
            onFocus={(e)=>e.target.select()}/>
            <img className='no-print' style={{marginLeft:'-26px',width:'24px',height:'24px',cursor:'pointer'}} src={icon+'#cal'} alt='' onClick={()=>setShow(disabled?false:true)}/>
        </div></label>
    )
}

export default EditIrg